import React, { Component } from 'react';
import PackageItemList from './PackageItemList';
import { NavLink } from 'react-router-dom';

const PackageDetail = (props) => {
  return (
    <div className="card">
      <div className="shipment-header-table d-flex justify-content-between align-items-center">
        <b>Package #{props.shipmentPackage.id}   |  {props.shipmentPackage.package_type ? props.shipmentPackage.package_type.name : 'N/A'}</b>
      </div>
      <PackageItemList items={props.shipmentPackage.items}/>
    </div>
  )
}

const EmptyPackagesList = () => {
  return (
    <div className="empty-message">
        <span>
          <span> There are no Packages for this Shipment</span>
        </span>
    </div>
  );
}

export default class ShipmentPackagesList extends Component {

  render() {
    if (this.props.packages.length > 0) {
      return (
        <div>
          <div className="d-flex justify-content-between align-items-center pb-05">
              <h5 className="mb-1">Packages</h5>
              <NavLink className="m-0 btn btn-danger" to={`/return/new/?s=${this.props.shipment.id}`}>
                <span><i className="fa fa-arrow-left mr-05"></i>Issue return</span>
              </NavLink>
          </div>


          {this.props.packages.map((pack,index)=>{
            return <PackageDetail shipmentPackage={pack} key={index}/>
          })}
        </div>
      );
    } else {
        return <EmptyPackagesList />
    }
  }
}
